import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { mapMany } from "keautils";
import { Cotizacion, CotizacionConcepto, CotizacionGrupo } from "./logic";

export interface Props {
    value: string[];
}

class Importe extends React.PureComponent<{ value: number }> {
    render() {
        return [
            <td key="1" style={{ textAlign: "right", fontFamily: "monospace" }} >$</td>,
            <td key="2" style={{ textAlign: "right", fontFamily: "monospace" }} >{kea.formatDecimal(this.props.value)}</td>
        ];
    }
}

class FilasObservacion extends React.PureComponent<{ value: string[] }> {
    render() {
        const x = this.props.value;
        return [
            <FilaTitulo key="titulO" titulo="Observaciones" />,
            ...x.map((x, i) => x ? <FilaItem value={x} /> : null)
        ];
    }
}

class FilaTitulo extends React.PureComponent<{ titulo: string }> {
    render() {
        return (
            <tr className="info" >
                <td colSpan={4}>
                    <label>{this.props.titulo}</label>
                </td>
            </tr>
        )
    }
}

class FilaItem extends React.PureComponent<{ value: string }> {
    render() {
        const x = this.props.value;
        return (
            <tr>
                <td colSpan={2} >{x}</td>
            </tr>
        )
    }
}

export class ObservacionesView extends React.PureComponent<Props> {
    render() {
        return (
            <table className="table table-sm">
                <tbody>
                    <FilasObservacion value={this.props.value} />
                </tbody>
            </table>
        );
    }
}


export class TiempoAproximado extends React.PureComponent<{ value: number }> {
    render() {
        return (
            <table className="table table-sm">
                <tbody>
                    <FilaTiempo value={this.props.value} />
                </tbody>
            </table>
        );
    }
}

class FilaTiempo extends React.PureComponent<{ value: number }> {
    render() {
        const x = this.props.value;
        return [
            <FilaTitulo key="titulO" titulo={"Tiempo estimado de entrega (" + kea.formatHours(x) + ") hr"} />
        ];
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/guias/observacionesview.tsx